import React, { type FC, useState } from 'react'
import { Box, Typography } from '@mui/material'

import { Dropdown, type DropdownOptionProps, type DropdownSize } from '../common'
import { SplitButtonControl } from './SplitButtonControl'

type Fruit = 'apple' | 'banana' | 'cherry'

const options: readonly DropdownOptionProps<Fruit>[] = [
    { value: 'apple', label: 'Apple' },
    { value: 'banana', label: 'Banana' },
    { value: 'cherry', label: 'Cherry' },
]

const sizes: readonly DropdownSize[] = ['small', 'medium']

const playgroundStyle = { display: 'flex', flexDirection: 'column', alignItems: 'flex-start' } as const
const exampleStyle = { width: 200, maxWidth: '100%' } as const

const DropdownPlayground: FC = () => {
    const [size, setSize] = useState<DropdownSize>('medium')
    const [value, setValue] = useState<Fruit>('apple')

    return (
        <Box sx={playgroundStyle}>
            <SplitButtonControl ariaLabel="Dropdown size" testIdPrefix="dropdown-storybook-size" option={size} options={sizes} onChange={setSize} />
            <Box sx={exampleStyle}>
                <Dropdown
                    data-testid="dropdown-storybook"
                    buttonLabel={options.find((option) => option.value === value)?.label}
                    options={options}
                    size={size}
                    value={value}
                    onChange={setValue}
                />
            </Box>
        </Box>
    )
}

const Dropdowns: FC = () => (
    <>
        <Typography variant="subtitle1" sx={{ display: 'block', mb: 4 }}>
            Dropdown
        </Typography>
        <DropdownPlayground />
    </>
)

export { Dropdowns }
